import type { FC } from "react";

import { cn } from "@/ui/lib/utils";
import {
  CONTAINER_DEFAULTS,
  TContainerProps,
} from "@/ui/components/layout/Container";

export const Container: FC<TContainerProps> = (
  {
    tag: Tag = CONTAINER_DEFAULTS.tag,
    "data-component": component = CONTAINER_DEFAULTS["data-component"],
    className,
    children,
    ...props
  },
) => (
  <Tag
    {...props}
    data-component={component}
    className={cn(
      "container mx-auto",
      className,
    )}
  >
    { children }
  </Tag>
);

Container.displayName = "Container";
